import { IconButton, Tooltip, Typography } from "@mui/material"
import { CommonService } from "../../Service/CommonService"
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useLocation } from "react-router";
import SearchIcon from "@mui/icons-material/Search";
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { useRoute } from "../Common/route";
import DataGridLoader from "../Common/DataGridLoader";

const TastingHistory = () => {
    const route = useRoute();
    const location = useLocation();
    const currentPath = location.pathname;
    const [showContainerTimeline, setShowContainerTimeline] = useState(false);
    const [showContainerHistory, setShowContainerHistory] = useState(false);
    const [rows, setRows] = React.useState([]);
    const [totalCount, setTotalCount] = React.useState(0);
    const [page, setPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(10);
    const [sortModel, setSortModel] = React.useState([]);
    const [searchText, setSearchText] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    function routeBack() {

    }
    const columns: GridColDef[] = [
        {
            field: "Timestamp",
            headerName: "Timestamp",
            flex: 1,
            minWidth: 200,
            headerClassName: "table-header border-0 my-2 h-100",
            renderHeader: (params) => (
                <div>
                    <Typography
                        variant="body2"
                        sx={{ color: "#6F6F6F", fontSize: "14px" }}
                    >
                        {params.colDef.headerName}
                    </Typography>
                    <div className="position-relative" style={{ width: "130px" }}>
                        <input
                            type="number"
                            className="form-control border mt-1"
                            style={{ textIndent: "24px", boxShadow: "none" }}
                            placeholder="Search"
                        />
                        <SearchIcon
                            sx={{
                                color: "#6F6F6F",
                                position: "absolute",
                                top: "50%",
                                left: "8px",
                                transform: "translateY(-50%)",
                            }}
                        />
                    </div>
                </div>
            ),
            renderCell: ({ row }) => (
                <>
                    Dec 11, 2025, 3:48 AM
                </>
            ),

        },
        {
            field: "Overall Score (1-10)",
            headerName: "Overall Score (1-10)",
            flex: 1,
            minWidth: 200,
            sortable: true,
            headerClassName: "table-header border-0 my-2 h-100",
            renderHeader: (params) => (
                <div>
                    <Typography
                        variant="body2"
                        sx={{ color: "#6F6F6F", fontSize: "14px" }}
                    >
                        {params.colDef.headerName}
                    </Typography>
                    <div className="position-relative" style={{ width: "130px" }}>
                        <input
                            type="number"
                            className="form-control border mt-1"
                            style={{ textIndent: "24px", boxShadow: "none" }}
                            placeholder="Search"
                        />
                        <SearchIcon
                            sx={{
                                color: "#6F6F6F",
                                position: "absolute",
                                top: "50%",
                                left: "8px",
                                transform: "translateY(-50%)",
                            }}
                        />
                    </div>
                </div>
            ),
            renderCell: ({ row }) => (
                <>
                    8
                </>
            ),

        },
        {
            field: "Blend Group ",
            headerName: "Blend Group ",
            flex: 1,
            minWidth: 200,
            sortable: true,
            headerClassName: "table-header border-0 my-2 h-100",
            renderHeader: (params) => (
                <div>
                    <Typography
                        variant="body2"
                        sx={{ color: "#6F6F6F", fontSize: "14px" }}
                    >
                        {params.colDef.headerName}
                    </Typography>
                    <div className="position-relative" style={{ width: "130px" }}>
                        <input
                            type="number"
                            className="form-control border mt-1"
                            style={{ textIndent: "24px", boxShadow: "none" }}
                            placeholder="Search"
                        />
                        <SearchIcon
                            sx={{
                                color: "#6F6F6F",
                                position: "absolute",
                                top: "50%",
                                left: "8px",
                                transform: "translateY(-50%)",
                            }}
                        />
                    </div>
                </div>
            ),
            renderCell: ({ row }) => (
                <>
                    CERAL - Grain - Rye
                </>
            ),

        },
        {
            field: "Color",
            headerName: "Color",
            flex: 1,
            minWidth: 200,
            sortable: true,
            headerClassName: "table-header border-0 my-2 h-100",
            renderHeader: (params) => (
                <div>
                    <Typography
                        variant="body2"
                        sx={{ color: "#6F6F6F", fontSize: "14px" }}
                    >
                        {params.colDef.headerName}
                    </Typography>
                    <div className="position-relative" style={{ width: "130px" }}>
                        <input
                            type="number"
                            className="form-control border mt-1"
                            style={{ textIndent: "24px", boxShadow: "none" }}
                            placeholder="Search"
                        />
                        <SearchIcon
                            sx={{
                                color: "#6F6F6F",
                                position: "absolute",
                                top: "50%",
                                left: "8px",
                                transform: "translateY(-50%)",
                            }}
                        />
                    </div>
                </div>
            ),
            renderCell: (params) => (
                <>
                    Deep Amber
                </>
            ),
        },
        {
            field: "Suitable for Direct Bottling",
            headerName: "Suitable for Direct Bottling",
            flex: 1,
            minWidth: 200,
            sortable: true,
            headerClassName: "table-header border-0 my-2 h-100",
            renderHeader: (params) => (
                <div>
                    <Typography
                        variant="body2"
                        sx={{ color: "#6F6F6F", fontSize: "14px" }}
                    >
                        {params.colDef.headerName}
                    </Typography>
                    <div className="position-relative" style={{ width: "130px" }}>
                        <input
                            type="number"
                            className="form-control border mt-1"
                            style={{ textIndent: "24px", boxShadow: "none" }}
                            placeholder="Search"
                        />
                        <SearchIcon
                            sx={{
                                color: "#6F6F6F",
                                position: "absolute",
                                top: "50%",
                                left: "8px",
                                transform: "translateY(-50%)",
                            }}
                        />
                    </div>
                </div>
            ),
            renderCell: (params) => (
                <>
                    Yes
                </>
            ),
        },
        {
            field: "Hold for Aging",
            headerName: "Hold for Aging",
            flex: 1,
            minWidth: 200,
            sortable: true,
            headerClassName: "table-header border-0 my-2 h-100",
            renderHeader: (params) => (
                <div>
                    <Typography
                        variant="body2"
                        sx={{ color: "#6F6F6F", fontSize: "14px" }}
                    >
                        {params.colDef.headerName}
                    </Typography>
                    <div className="position-relative" style={{ width: "130px" }}>
                        <input
                            type="number"
                            className="form-control border mt-1"
                            style={{ textIndent: "24px", boxShadow: "none" }}
                            placeholder="Search"
                        />
                        <SearchIcon
                            sx={{
                                color: "#6F6F6F",
                                position: "absolute",
                                top: "50%",
                                left: "8px",
                                transform: "translateY(-50%)",
                            }}
                        />
                    </div>
                </div>
            ),
            renderCell: (params) => (
                <>
                    Yes
                </>
            ),
        },
        {
            field: "Blender Comments",
            headerName: "Blender Comments",
            flex: 1,
            minWidth: 200,
            sortable: true,
            headerClassName: "table-header border-0 my-2 h-100",
            renderHeader: (params) => (
                <div>
                    <Typography
                        variant="body2"
                        sx={{ color: "#6F6F6F", fontSize: "14px" }}
                    >
                        {params.colDef.headerName}
                    </Typography>
                    <div className="position-relative" style={{ width: "130px" }}>
                        <input
                            type="number"
                            className="form-control border mt-1"
                            style={{ textIndent: "24px", boxShadow: "none" }}
                            placeholder="Search"
                        />
                        <SearchIcon
                            sx={{
                                color: "#6F6F6F",
                                position: "absolute",
                                top: "50%",
                                left: "8px",
                                transform: "translateY(-50%)",
                            }}
                        />
                    </div>
                </div>
            ),
            renderCell: (params) => (
                <>
                    Strong rye-forward profile with excellent spice character and... balanced oak integration. Suitable for spicy blend
                </>
            ),
        },
        {
            field: "Actions",
            headerName: "Actions",
            flex: 1,
            minWidth: 200,
            sortable: true,
            headerClassName: "table-header border-0 my-2 h-100",
            renderHeader: (params) => (
                <div>
                    <Typography
                        variant="body2"
                        sx={{ color: "#6F6F6F", fontSize: "14px" }}
                    >
                        {params.colDef.headerName}
                    </Typography>
                </div>
            ),
            renderCell: (params) => (
                <>
                    <Tooltip title="View" arrow>
                        <IconButton
                            aria-label="View"
                            size="small"
                            onClick={() => route("/master/tasting-history-detail")}
                        >
                            <RemoveRedEyeOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                </>
            ),
        },
    ];
    /* ---------- Fake API Call (Replace with real API) ---------- */
    const fetchData = React.useCallback(async () => {
        setLoading(true);

        // Simulated server delay
        await new Promise((r) => setTimeout(r, 500));

        // Fake data
        const allData = Array.from({ length: 57 }, (_, i) => ({
            id: i + 1,
            name: `Item ${i + 1}`,
            sku: `SKU-${1000 + i}`,
            quantity: Math.floor(Math.random() * 100),
            location: ["A1", "B2", "C3"][i % 3],
        }));

        // Search
        const filtered = allData.filter(
            (row) =>
                row.name.toLowerCase().includes(searchText.toLowerCase()) ||
                row.location.toLowerCase().includes(searchText.toLowerCase())
        );

        // Sort
        const sorted = sortModel.length
            ? [...filtered].sort((a, b) => {
                const { field, sort } = sortModel[0];
                return sort === "asc"
                    ? a[field] > b[field]
                        ? 1
                        : -1
                    : a[field] < b[field]
                        ? 1
                        : -1;
            })
            : filtered;

        // Pagination
        const paginated = sorted.slice(
            page * pageSize,
            page * pageSize + pageSize
        );

        setRows(paginated);
        setTotalCount(filtered.length);
        setLoading(false);
    }, [page, pageSize, sortModel, searchText]);

    React.useEffect(() => {
        fetchData();
    }, [fetchData]);
    return (
        <>
            <div
                className="usersList usersList__user tasting-history-detail"
                style={{ paddingBottom: CommonService.isAdmin() ? 47 : "" }}>
                <div className="usersList__header--wrapper d-flex flex-wrap align-items-center w-100">
                    <div className="d-flex align-items-center justify-content-between w-100 flex-wrap gap-2 position-relative">
                        <div className="d-flex align-items-center gap-2 flex-wrap left-wrapper">
                            {CommonService.isAdmin() && (
                                <>
                                    <div className="back__button" onClick={routeBack}>

                                        <IconButton
                                            aria-label="ArrowBackIcon"
                                            sx={{ backgroundColor: "#FFF" }}
                                        >
                                            <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                                        </IconButton>
                                    </div>

                                    <div className="header--title">
                                        <h1 className="title mb-0">
                                            Tasting History
                                        </h1>
                                    </div>
                                    <div className="divider mx-2"></div>
                                </>
                            )}
                            <div className="header--title d-flex flex-wrap me-auto mb-xxl-0 gap-2 gap-xxl-3">
                                <div className="time__details me-4 me-xl-4 mb-0">
                                    <Typography
                                        variant="h6"
                                        sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                                    >
                                        Container Number
                                    </Typography>
                                    <Typography
                                        variant="h3"
                                        sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
                                    >
                                        17-17107
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="user-table-container position-relative">
                    <div className="userTable ">
                        <DataGrid
                            className="data-grid data-grid__myinventories support-req--listing"
                            rows={rows}
                            columns={columns}
                            loading={loading}
                            slots={{
                                loadingOverlay: DataGridLoader,
                            }}
                            rowCount={totalCount}
                            pagination
                            paginationMode="server"
                            sortingMode="server"
                            paginationModel={{ page, pageSize }}
                            onPaginationModelChange={({ page, pageSize }) => {
                                setPage(page);
                                setPageSize(pageSize);
                            }}
                            onSortModelChange={(model) => setSortModel(model)}
                            pageSizeOptions={[10, 20, 50]}
                            disableRowSelectionOnClick
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
export default TastingHistory;